'use client'

import { useEffect, useState } from 'react'
import { useRouter } from 'next/navigation'
import styles from './UnpaidOrderNotice.module.css'
import { createPortal } from 'react-dom'

export default function UnpaidOrderNotice() {
  const router = useRouter()

  const [open, setOpen] = useState(false)
  const [loading, setLoading] = useState(true)
  const [orders, setOrders] = useState([])

  const getUnpaidOrders = async () => {
    try {
      setLoading(true)

      const response = await fetch(`/api/order/get_UnpaidOrder`, {
        method: 'GET',
        cache: 'no-store',
      })

      if (!response.ok) {
        setOrders([])
        return
      }

      const result = await response.json()

      if (result?.Error) {
        console.error('取得未付款訂單失敗：', result.Error)
        setOrders([])
        return
      }

      const data = result?.Data?.Data ?? result?.Data ?? []

      const now = new Date()

      const validOrders = Array.isArray(data)
        ? data.filter((order) => {
            if (!order.PaymentDeadline) return false

            const deadline = new Date(order.PaymentDeadline)

            return !Number.isNaN(deadline.getTime()) && deadline >= now
          })
        : []

      setOrders(validOrders)
    } catch (error) {
      console.error('取得未付款訂單失敗：', error)
      setOrders([])
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date()

      setOrders((prev) =>
        prev.filter((order) => {
          if (!order.PaymentDeadline) return false

          const deadline = new Date(order.PaymentDeadline)

          return !Number.isNaN(deadline.getTime()) && deadline >= now
        })
      )
    }, 60000)

    return () => clearInterval(timer)
  }, [])

  useEffect(() => {
    getUnpaidOrders()
  }, [])

  useEffect(() => {
    if (!loading && orders.length === 0) {
      setOpen(false)
    }
  }, [loading, orders.length])

  // API 還在讀取時不顯示
  if (loading) {
    return null
  }

  // 沒有未付款訂單就不顯示圓球
  if (orders.length === 0) {
    return null
  }

  const handleOrderClick = () => {
    setOpen(false)
    router.push('/MemberCenter/account_orders')
  }

  return (
    <>
      {/* 右下角通知圓球 */}
      <button
        type="button"
        className={styles.floatingButton}
        onClick={() => setOpen(true)}
        aria-label="未付款訂單"
      >
        <i className="bi bi-credit-card-fill" />

        <span className={styles.badge}>
          {orders.length > 99 ? '99+' : orders.length}
        </span>
      </button>

      {/* 未付款訂單 Modal */}
      {open &&
        createPortal(
          <div className={styles.modalOverlay} onClick={() => setOpen(false)}>
            <div
              className={styles.modalBox}
              role="dialog"
              aria-modal="true"
              aria-labelledby="unpaid-order-title"
              onClick={(e) => e.stopPropagation()}
            >
              <div className={styles.modalHeader}>
                <div className={styles.modalTitle} id="unpaid-order-title">
                  <i className="bi bi-exclamation-circle-fill" />
                  尚有訂單未付款
                </div>

                <button
                  type="button"
                  className={styles.closeButton}
                  onClick={() => setOpen(false)}
                  aria-label="關閉通知"
                >
                  <i className="bi bi-x-lg" />
                </button>
              </div>

              <div className={styles.description}>
                您目前有 <strong>{orders.length}</strong> 筆訂單尚未完成付款
              </div>

              <div className={styles.orderList}>
                {orders.map((order) => (
                  <div key={order.OrderID} className={styles.orderItem}>
                    <div>
                      <div className={styles.orderNumber}>
                        訂單編號：{order.OrderID}
                      </div>

                      {order.OrderDT && (
                        <div className={styles.orderDate}>
                          訂單日期：
                          {new Date(order.OrderDT).toLocaleString('zh-TW')}
                        </div>
                      )}

                      {order.PaymentDeadline && (
                        <div className={styles.orderDate}>
                          付款期限：
                          {new Date(order.PaymentDeadline).toLocaleString(
                            'zh-TW'
                          )}
                        </div>
                      )}
                    </div>

                    <div className={styles.right}>
                      {order.TotalPaidCost != null && (
                        <div className={styles.amount}>
                          NT$ {Number(order.TotalPaidCost).toLocaleString()}
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              {/* 前往我的訂單 */}
              <div className={styles.modalFooter}>
                <button
                  type="button"
                  className={styles.orderButton}
                  onClick={handleOrderClick}
                >
                  前往我的訂單
                  <i className="bi bi-arrow-right ms-2" />
                </button>
              </div>
            </div>
          </div>,
          document.body
        )}
    </>
  )
}
